import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pwa-home" }
const _hoisted_2 = { class: "home-header" }
const _hoisted_3 = { class: "header-left" }
const _hoisted_4 = { class: "greeting" }
const _hoisted_5 = { class: "user-name" }
const _hoisted_6 = { class: "header-right" }
const _hoisted_7 = { class: "center-icon" }
const _hoisted_8 = { class: "center-info" }
const _hoisted_9 = { class: "center-name" }
const _hoisted_10 = { class: "notice-icon" }
const _hoisted_11 = { class: "notice-text" }
const _hoisted_12 = { class: "month-summary" }
const _hoisted_13 = { class: "summary-header" }
const _hoisted_14 = { class: "summary-title" }
const _hoisted_15 = { class: "summary-stats" }
const _hoisted_16 = { class: "stat-item" }
const _hoisted_17 = { class: "stat-value" }
const _hoisted_18 = { class: "stat-item" }
const _hoisted_19 = { class: "stat-value" }
const _hoisted_20 = { class: "stat-item" }
const _hoisted_21 = { class: "stat-value" }
const _hoisted_22 = { class: "section" }
const _hoisted_23 = { class: "section-header" }
const _hoisted_24 = { class: "section" }
const _hoisted_25 = { class: "section-header" }
const _hoisted_26 = { class: "section-title" }
const _hoisted_27 = { class: "annual-stats" }
const _hoisted_28 = { class: "annual-card" }
const _hoisted_29 = { class: "annual-icon blue" }
const _hoisted_30 = { class: "annual-info" }
const _hoisted_31 = { class: "annual-value" }
const _hoisted_32 = { class: "annual-card" }
const _hoisted_33 = { class: "annual-icon green" }
const _hoisted_34 = { class: "annual-info" }
const _hoisted_35 = { class: "annual-value" }
const _hoisted_36 = { class: "annual-card" }
const _hoisted_37 = { class: "annual-icon purple" }
const _hoisted_38 = { class: "annual-info" }
const _hoisted_39 = { class: "annual-value" }
const _hoisted_40 = { class: "annual-card" }
const _hoisted_41 = { class: "annual-icon orange" }
const _hoisted_42 = { class: "annual-info" }
const _hoisted_43 = { class: "annual-value" }
const _hoisted_44 = { class: "section" }
const _hoisted_45 = { class: "quick-menu" }
const _hoisted_46 = { class: "quick-icon" }
const _hoisted_47 = { class: "quick-icon" }
const _hoisted_48 = { class: "quick-icon" }
const _hoisted_49 = { class: "quick-icon" }
const _hoisted_50 = {
  key: 1,
  class: "section"
}
const _hoisted_51 = { class: "section-header" }
const _hoisted_52 = { class: "notice-list" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "notice-title" }
const _hoisted_55 = { class: "notice-date" }
const _hoisted_56 = { class: "sheet-header" }
const _hoisted_57 = { class: "sheet-content" }
const _hoisted_58 = { class: "sheet-header" }
const _hoisted_59 = { class: "sheet-content" }
const _hoisted_60 = { class: "year-grid" }
const _hoisted_61 = ["onClick"]

import { ref, computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import axios from 'axios';
import LodingComponent from '@/components/loading/LodingComponent.vue';
import PwaWageProcessStatus from '@/components/pwa/PwaWageProcessStatus.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PwaHome',
  setup(__props) {

const store = useStore();
const router = useRouter();

const userInfo = computed(() => store.state.user);
const isLoading = ref(false);
const loadingText = ref('로딩 중...');
const selectedYear = computed(() => store.state.pwa.selectedYear);
const showYearPicker = ref(false);
const showCenterMenu = ref(false);
const wageMagamData = ref<any[]>([]);
const latestNotice = ref<{ nc_idx: number; nc_title: string } | null>(null);
const notices = ref<any[]>([]);

const currentYear = new Date().getFullYear();
const availableYears = computed(() => 
  Array.from({ length: 6 }, (_, i) => currentYear - 3 + i)
);

// 인사말
const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return '좋은 아침이에요,';
  if (hour < 18) return '안녕하세요,';
  return '좋은 저녁이에요,';
};

// 최신 마감 월
const getLatestMonth = () => {
  const latest = getLatestMagamMonth();
  return latest?.month || new Date().getMonth() + 1;
};

const getLatestMagamMonth = (): { month: number; yearMonth: string } | null => {
  if (!wageMagamData.value || wageMagamData.value.length === 0) return null;
  
  const totalData = wageMagamData.value.filter(item => item.wm_job_type === '전체합계');
  if (totalData.length === 0) return null;
  
  const sortedData = [...totalData].sort((a, b) => {
    const aYm = parseInt(a.wm_ym || '0');
    const bYm = parseInt(b.wm_ym || '0');
    return bYm - aYm;
  });
  
  if (sortedData.length === 0) return null;
  
  const latest = sortedData[0];
  const yearMonth = latest.wm_ym || '';
  const month = parseInt(yearMonth.substring(4, 6));
  
  return { month, yearMonth };
};

// 마감 상태
const getMagamStatus = () => {
  const latest = getLatestMagamMonth();
  if (!latest) return 'pending';
  
  const latestData = wageMagamData.value.find(
    item => item.wm_job_type === '전체합계' && item.wm_ym === latest.yearMonth
  );
  
  return latestData?.wm_isuse === 'y' ? 'closed' : 'progress';
};

const getMagamStatusText = () => {
  const status = getMagamStatus();
  if (status === 'closed') return '마감완료';
  if (status === 'progress') return '진행중';
  return '미시작';
};

// 최근 월 데이터
const getLatestMonthData = () => {
  const latest = getLatestMagamMonth();
  if (!latest) return null;
  
  const latestData = wageMagamData.value.find(
    item => item.wm_job_type === '전체합계' && item.wm_ym === latest.yearMonth
  );
  
  if (!latestData) return null;
  
  return {
    month: latest.month,
    wage: parseInt(latestData.wm_wage_sum) || 0,
    profit: parseInt(latestData.wm_center_profit) || 0,
    savings: parseInt(latestData.wm_center_savings) || 0,
    count: parseInt(latestData.wm_count) || 0
  };
};

// KPI 계산
const getTotalWage = (): number => {
  if (!wageMagamData.value || wageMagamData.value.length === 0) return 0;
  return wageMagamData.value
    .filter(item => item.wm_job_type === '전체합계')
    .reduce((sum, item) => sum + (parseInt(item.wm_wage_sum) || 0), 0);
};

const getTotalProfit = (): number => {
  if (!wageMagamData.value || wageMagamData.value.length === 0) return 0;
  return wageMagamData.value
    .filter(item => item.wm_job_type === '전체합계')
    .reduce((sum, item) => sum + (parseInt(item.wm_center_profit) || 0), 0);
};

const getAverageEmployeeCount = (): number => {
  if (!wageMagamData.value || wageMagamData.value.length === 0) return 0;
  const totalData = wageMagamData.value.filter(item => item.wm_job_type === '전체합계');
  if (totalData.length === 0) return 0;
  const totalCount = totalData.reduce((sum, item) => sum + (parseInt(item.wm_count) || 0), 0);
  return Math.round(totalCount / totalData.length);
};

const getTotalSavings = (): number => {
  if (!wageMagamData.value || wageMagamData.value.length === 0) return 0;
  return wageMagamData.value
    .filter(item => item.wm_job_type === '전체합계')
    .reduce((sum, item) => sum + (parseInt(item.wm_center_savings) || 0), 0);
};

// 포맷
const formatCurrency = (value: number): string => {
  return value.toLocaleString();
};

const formatShortCurrency = (value: number): string => {
  if (value >= 100000000) {
    return `${(value / 100000000).toFixed(1)}억`;
  }
  if (value >= 10000) {
    return `${Math.floor(value / 10000).toLocaleString()}만`;
  }
  return value.toLocaleString();
};

const formatNoticeDate = (dateStr: string) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return `${date.getMonth() + 1}.${date.getDate()}`;
};

// 데이터 조회
const fetchYearlyWageMagamData = async (year: number) => {
  try {
    const user = store.state.user;
    if (!user || !user.m_sisul_code) return;

    isLoading.value = true;
    loadingText.value = '데이터를 불러오는 중...';
    
    const response = await axios.get(`/api/calc/wage-magam-yearly/${user.m_sisul_code}/${year}`, {
      withCredentials: true
    });

    if (response.data.success) {
      wageMagamData.value = response.data.data || [];
    } else {
      wageMagamData.value = [];
    }
  } catch (error) {
    console.error('급여 마감 데이터 조회 오류:', error);
    wageMagamData.value = [];
  } finally {
    isLoading.value = false;
  }
};

const loadNotices = async () => {
  try {
    const response = await axios.get('/api/notice/list', {
      params: { page: 1, limit: 5 },
      withCredentials: true
    });
    
    if (response.data.success) {
      notices.value = response.data.notices || [];
      if (notices.value.length > 0) {
        latestNotice.value = notices.value[0];
      }
    }
  } catch (error) {
    console.error('공지사항 로드 오류:', error);
  }
};

// 네비게이션
const selectYear = async (year: number) => {
  store.commit('pwa/setPwaYear', year);
  showYearPicker.value = false;
  await fetchYearlyWageMagamData(year);
};

const goToNotice = () => router.push('/pwa/notice');
const goToNoticeDetail = (id: number) => router.push(`/pwa/notice/${id}`);
const goToUserInfo = () => {
  showCenterMenu.value = false;
  router.push('/pwa/userinfo');
};

const handleInquiry = () => {
  showCenterMenu.value = false;
  window.location.href = 'tel:070-1234-5678';
};

const handleLogout = async () => {
  showCenterMenu.value = false;
  try {
    await store.dispatch('pwa/performPwaLogout');
  } catch (error) {
    console.error('로그아웃 오류:', error);
    store.commit('pwa/clearPwaUser');
  }
  router.push('/pwa/login');
};

onMounted(async () => {
  const savedYear = localStorage.getItem('pwa_selectedYear');
  if (savedYear) {
    const year = parseInt(savedYear, 10);
    if (!isNaN(year) && year !== store.state.pwa.selectedYear) {
      store.commit('pwa/setPwaYear', year);
    }
  }
  
  const year = store.state.pwa.selectedYear;
  await Promise.all([
    fetchYearlyWageMagamData(year),
    loadNotices()
  ]);
});

watch(
  () => store.state.pwa.selectedYear,
  async (newYear) => {
    if (newYear) {
      await fetchYearlyWageMagamData(newYear);
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(getGreeting()), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(userInfo.value?.m_name || userInfo.value?.m_user_name || '센터장') + "님", 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "year-chip",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showYearPicker.value = true))
        }, [
          _createTextVNode(_toDisplayString(selectedYear.value) + "년 ", 1),
          _createVNode(_component_v_icon, { size: "14" }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createTextVNode("mdi-chevron-down", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "center-card",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (showCenterMenu.value = true))
    }, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_v_icon, {
          size: "24",
          color: "white"
        }, {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
            _createTextVNode("mdi-domain", -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(userInfo.value?.m_sisul_name || '센터'), 1),
        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "center-status" }, [
          _createElementVNode("span", { class: "status-dot" }),
          _createTextVNode(" 운영중 ")
        ], -1))
      ]),
      _createVNode(_component_v_icon, {
        size: "20",
        color: "#ccc"
      }, {
        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
          _createTextVNode("mdi-chevron-right", -1)
        ]))]),
        _: 1
      })
    ]),
    (latestNotice.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "notice-card",
          onClick: goToNotice
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_v_icon, {
              size: "16",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                _createTextVNode("mdi-bullhorn", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("span", _hoisted_11, _toDisplayString(latestNotice.value.nc_title), 1),
          _createVNode(_component_v_icon, {
            size: "16",
            color: "#999"
          }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
              _createTextVNode("mdi-chevron-right", -1)
            ]))]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("span", _hoisted_14, _toDisplayString(getLatestMonth()) + "월 현황", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["summary-badge", getMagamStatus()])
        }, _toDisplayString(getMagamStatusText()), 3)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", _hoisted_17, [
            _createTextVNode(_toDisplayString(getLatestMonthData()?.count || 0), 1),
            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "stat-unit" }, "명", -1))
          ]),
          _cache[19] || (_cache[19] = _createElementVNode("span", { class: "stat-label" }, "급여 대상", -1))
        ]),
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "stat-divider" }, null, -1)),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("span", _hoisted_19, _toDisplayString(formatShortCurrency(getLatestMonthData()?.wage || 0)), 1),
          _cache[20] || (_cache[20] = _createElementVNode("span", { class: "stat-label" }, "총 인건비", -1))
        ]),
        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "stat-divider" }, null, -1)),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("span", _hoisted_21, _toDisplayString(formatShortCurrency(getLatestMonthData()?.profit || 0)), 1),
          _cache[21] || (_cache[21] = _createElementVNode("span", { class: "stat-label" }, "센터 수익", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _cache[26] || (_cache[26] = _createElementVNode("span", { class: "section-title" }, "임금관리", -1)),
        _createElementVNode("button", {
          class: "section-more",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/pwa/payroll')))
        }, [
          _cache[25] || (_cache[25] = _createTextVNode(" 상세보기 ", -1)),
          _createVNode(_component_v_icon, { size: "14" }, {
            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
              _createTextVNode("mdi-chevron-right", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _createVNode(PwaWageProcessStatus, { "selected-year": selectedYear.value }, null, 8, ["selected-year"])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("span", _hoisted_26, _toDisplayString(selectedYear.value) + "년 연간 통계", 1)
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_v_icon, {
              size: "20",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                _createTextVNode("mdi-cash-multiple", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_30, [
            _cache[28] || (_cache[28] = _createElementVNode("span", { class: "annual-label" }, "총 인건비", -1)),
            _createElementVNode("span", _hoisted_31, _toDisplayString(formatCurrency(getTotalWage())) + "원", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_v_icon, {
              size: "20",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                _createTextVNode("mdi-chart-line", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_34, [
            _cache[30] || (_cache[30] = _createElementVNode("span", { class: "annual-label" }, "센터 수익", -1)),
            _createElementVNode("span", _hoisted_35, _toDisplayString(formatCurrency(getTotalProfit())) + "원", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_v_icon, {
              size: "20",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                _createTextVNode("mdi-account-group", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_38, [
            _cache[32] || (_cache[32] = _createElementVNode("span", { class: "annual-label" }, "평균 인원", -1)),
            _createElementVNode("span", _hoisted_39, _toDisplayString(getAverageEmployeeCount()) + "명", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createVNode(_component_v_icon, {
              size: "20",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                _createTextVNode("mdi-piggy-bank", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_42, [
            _cache[34] || (_cache[34] = _createElementVNode("span", { class: "annual-label" }, "총 절감액", -1)),
            _createElementVNode("span", _hoisted_43, _toDisplayString(formatCurrency(getTotalSavings())) + "원", 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _cache[43] || (_cache[43] = _createElementVNode("div", { class: "section-header" }, [
        _createElementVNode("span", { class: "section-title" }, "빠른 메뉴")
      ], -1)),
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("button", {
          class: "quick-btn",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/pwa/employees')))
        }, [
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_v_icon, { size: "22" }, {
              default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                _createTextVNode("mdi-account-group", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[36] || (_cache[36] = _createElementVNode("span", null, "직원관리", -1))
        ]),
        _createElementVNode("button", {
          class: "quick-btn",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/pwa/payroll')))
        }, [
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_v_icon, { size: "22" }, {
              default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                _createTextVNode("mdi-currency-krw", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[38] || (_cache[38] = _createElementVNode("span", null, "급여관리", -1))
        ]),
        _createElementVNode("button", {
          class: "quick-btn",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/pwa/finance')))
        }, [
          _createElementVNode("div", _hoisted_48, [
            _createVNode(_component_v_icon, { size: "22" }, {
              default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                _createTextVNode("mdi-chart-bar", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[40] || (_cache[40] = _createElementVNode("span", null, "회계관리", -1))
        ]),
        _createElementVNode("button", {
          class: "quick-btn",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/pwa/report')))
        }, [
          _createElementVNode("div", _hoisted_49, [
            _createVNode(_component_v_icon, { size: "22" }, {
              default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                _createTextVNode("mdi-file-chart", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[42] || (_cache[42] = _createElementVNode("span", null, "보고서", -1))
        ])
      ])
    ]),
    (notices.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _cache[46] || (_cache[46] = _createElementVNode("span", { class: "section-title" }, "공지사항", -1)),
            _createElementVNode("button", {
              class: "section-more",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push('/pwa/notice')))
            }, [
              _cache[45] || (_cache[45] = _createTextVNode(" 더보기 ", -1)),
              _createVNode(_component_v_icon, { size: "14" }, {
                default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                  _createTextVNode("mdi-chevron-right", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notices.value.slice(0, 3), (notice) => {
              return (_openBlock(), _createElementBlock("div", {
                key: notice.nc_idx,
                class: "notice-item",
                onClick: ($event: any) => (goToNoticeDetail(notice.nc_idx))
              }, [
                _createElementVNode("span", _hoisted_54, _toDisplayString(notice.nc_title), 1),
                _createElementVNode("span", _hoisted_55, _toDisplayString(formatNoticeDate(notice.nc_wdate)), 1)
              ], 8, _hoisted_53))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["sheet-overlay", { open: showCenterMenu.value }]),
      onClick: _cache[8] || (_cache[8] = ($event: any) => (showCenterMenu.value = false))
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["sheet", { open: showCenterMenu.value }])
    }, [
      _cache[57] || (_cache[57] = _createElementVNode("div", { class: "sheet-handle" }, null, -1)),
      _createElementVNode("div", _hoisted_56, [
        _cache[48] || (_cache[48] = _createElementVNode("span", { class: "sheet-title" }, "메뉴", -1)),
        _createElementVNode("button", {
          class: "sheet-close",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (showCenterMenu.value = false))
        }, [
          _createVNode(_component_v_icon, { size: "20" }, {
            default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
              _createTextVNode("mdi-close", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("div", {
          class: "menu-item",
          onClick: goToUserInfo
        }, [
          _createVNode(_component_v_icon, {
            size: "22",
            color: "#1e3a8a"
          }, {
            default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
              _createTextVNode("mdi-account-circle", -1)
            ]))]),
            _: 1
          }),
          _cache[51] || (_cache[51] = _createElementVNode("span", null, "내 정보", -1)),
          _createVNode(_component_v_icon, {
            size: "18",
            color: "#ccc"
          }, {
            default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
              _createTextVNode("mdi-chevron-right", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          class: "menu-item",
          onClick: handleInquiry
        }, [
          _createVNode(_component_v_icon, {
            size: "22",
            color: "#1e3a8a"
          }, {
            default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
              _createTextVNode("mdi-headset", -1)
            ]))]),
            _: 1
          }),
          _cache[53] || (_cache[53] = _createElementVNode("span", null, "고객센터", -1)),
          _cache[54] || (_cache[54] = _createElementVNode("span", { class: "menu-sub" }, "070-1234-5678", -1))
        ]),
        _createElementVNode("div", {
          class: "menu-item logout",
          onClick: handleLogout
        }, [
          _createVNode(_component_v_icon, {
            size: "22",
            color: "#ef4444"
          }, {
            default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
              _createTextVNode("mdi-logout", -1)
            ]))]),
            _: 1
          }),
          _cache[56] || (_cache[56] = _createElementVNode("span", null, "로그아웃", -1))
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["sheet-overlay", { open: showYearPicker.value }]),
      onClick: _cache[10] || (_cache[10] = ($event: any) => (showYearPicker.value = false))
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["sheet", { open: showYearPicker.value }])
    }, [
      _cache[60] || (_cache[60] = _createElementVNode("div", { class: "sheet-handle" }, null, -1)),
      _createElementVNode("div", _hoisted_58, [
        _cache[59] || (_cache[59] = _createElementVNode("span", { class: "sheet-title" }, "연도 선택", -1)),
        _createElementVNode("button", {
          class: "sheet-close",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (showYearPicker.value = false))
        }, [
          _createVNode(_component_v_icon, { size: "20" }, {
            default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
              _createTextVNode("mdi-close", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_59, [
        _createElementVNode("div", _hoisted_60, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableYears.value, (year) => {
            return (_openBlock(), _createElementBlock("button", {
              key: year,
              class: _normalizeClass(["year-btn", { active: selectedYear.value === year }]),
              onClick: ($event: any) => (selectYear(year))
            }, _toDisplayString(year) + "년 ", 11, _hoisted_61))
          }), 128))
        ])
      ])
    ], 2),
    _createVNode(LodingComponent, {
      "is-visible": isLoading.value,
      text: loadingText.value
    }, null, 8, ["is-visible", "text"])
  ]))
}
}

})